import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomReportService from '_services/custom-report-service';
import { PRMCodes } from '_utils/constants';

const columns = [
  { value: 'id', label: 'ID', category: 'Passenger Information' },
  { value: 'name', label: 'Name', category: 'Passenger Information' },
  { value: 'assistance', label: 'Assistance', category: 'Passenger Information' },

  { value: 'flightNumber', label: 'Flight Number', category: 'Flight Information' },
  { value: 'origin', label: 'Origin', category: 'Flight Information' },
  { value: 'destination', label: 'Destination', category: 'Flight Information' },
  { value: 'type', label: 'Type', category: 'Flight Information' },
  { value: 'airline', label: 'Airline', category: 'Flight Information' },
  { value: 'std', label: 'STD', category: 'Flight Information' },
  { value: 'sta', label: 'STA', category: 'Flight Information' },
  { value: 'atd', label: 'ATD', category: 'Flight Information' },
  { value: 'ata', label: 'ATA', category: 'Flight Information' },
  { value: 'startBoarding', label: 'Start Boarding', category: 'Flight Information' },
  { value: 'endBoarding', label: 'End Boarding', category: 'Flight Information' },
  { value: 'flightDate', label: 'Flight Date', category: 'Flight Information' },
  { value: 'month', label: 'Flight Month', category: 'Flight Information' },
  { value: 'gate', label: 'Gate', category: 'Flight Information' },
  { value: 'stand', label: 'Stand', category: 'Flight Information' },
  { value: 'terminal', label: 'Terminal', category: 'Flight Information' },
  { value: 'flightStatus', label: 'Flight Status', category: 'Flight Information' },
  { value: 'operatingStatus', label: 'Operating Status', category: 'Flight Information' },
  { value: 'aircraftType', label: 'Aircraft Type', category: 'Flight Information' },
  { value: 'aircraftRegistration', label: 'Aircraft Registration', category: 'Flight Information' },
  { value: 'slot', label: 'Slot', category: 'Flight Information' },
  { value: 'flightCancelled', label: 'Flight Cancelled', category: 'Flight Information' },
  { value: 'callSign', label: 'Call Sign', category: 'Flight Information' },

  { value: 'createdAt', label: 'Created At', category: 'Passenger Information' },
  { value: 'preAdvised', label: 'Pre-Advised', category: 'Passenger Information' },
  { value: 'nonPreAdvised', label: 'Non Pre-Advised', category: 'Passenger Information' },
  { value: 'preAdvisedStatus', label: 'Pre-Advised Status', category: 'Passenger Information' },
  { value: 'status', label: 'Status', category: 'Passenger Information' },
  { value: 'noShow', label: 'No Show', category: 'Passenger Information' },
  { value: 'rejectedPax', label: 'Rejected Pax', category: 'Passenger Information' },
  /*{ value: 'allocatedBy', label: 'Allocator', category: 'Airport Activity' },*/

  { value: 'departureAssistance', label: 'Departure Assistance', category: 'Airport Activity' },
  { value: 'arrivalAssistance', label: 'Arrival Assistance', category: 'Airport Activity' },
  { value: 'walkUp', label: 'Walk-Up', category: 'Airport Activity' },
  { value: 'selfAssisted', label: 'Self Assisted', category: 'Airport Activity' },
  { value: 'checkInTime', label: 'Checked In Time', category: 'Airport Activity' },
  { value: 'agent', label: 'Agent', category: 'Airport Activity' },
  { value: 'agentCount', label: 'Agent Count', category: 'Airport Activity' },
  { value: 'pickupLocation', label: 'Pickup Location', category: 'Airport Activity' },
  { value: 'dropoffLocation', label: 'Dropoff Location', category: 'Airport Activity' },
  { value: 'completionDuration', label: 'Trip Duration', category: 'Airport Activity' },
  { value: 'rampAllocatedTime', label: 'Ramp Allocated Time', category: 'Ramp Journey' },
  { value: 'rampWaitingTime', label: 'Ramp Waiting Time', category: 'Ramp Journey' },
  { value: 'rampStartTime', label: 'Ramp Start Time', category: 'Ramp Journey' },
  { value: 'rampAtLocationTime', label: 'Ramp At Location Time', category: 'Ramp Journey' },
  { value: 'rampCompleteTime', label: 'Ramp Complete Time', category: 'Ramp Journey' },
  { value: 'rampPickupLocation', label: 'Ramp Pickup Location', category: 'Ramp Journey' },
  { value: 'rampDropoffLocation', label: 'Ramp Dropoff Location', category: 'Ramp Journey' },
  { value: 'rampTaskNotes', label: 'Ramp Task Notes', category: 'Ramp Journey' },
  { value: 'arrivalAllocatedTime', label: 'Arrival Allocated Time', category: 'Arrival Journey' },
  { value: 'arrivalWaitingTime', label: 'Arrival Waiting Time', category: 'Arrival Journey' },
  { value: 'arrivalStartTime', label: 'Arrival Start Time', category: 'Arrival Journey' },
  { value: 'arrivalAtLocationTime', label: 'Arrival At Location Time', category: 'Arrival Journey' },
  { value: 'arrivalCompleteTime', label: 'Arrival Complete Time', category: 'Arrival Journey' },
  { value: 'arrivalPickupLocation', label: 'Arrival Pickup Location', category: 'Arrival Journey' },
  { value: 'arrivalDropoffLocation', label: 'Arrival Dropoff Location', category: 'Arrival Journey' },
  { value: 'arrivalTaskNotes', label: 'Arrival Task Notes', category: 'Arrival Journey' },
  { value: 'preBoardAllocatedTime', label: 'Departure Allocated Time', category: 'Departure Journey' },
  { value: 'preBoardWaitingTime', label: 'Check In Waiting Time', category: 'Departure Journey' },
  { value: 'preBoardStartTime', label: 'Departure Start Time', category: 'Departure Journey' },
  { value: 'preBoardAtLocationTime', label: 'Departure At Location Time', category: 'Departure Journey' },
  { value: 'preBoardCompleteTime', label: 'Departure Complete Time', category: 'Departure Journey' },
  { value: 'preBoardPickupLocation', label: 'Check In Location', category: 'Departure Journey' },
  { value: 'boardingPickupLocation', label: 'Departure Pickup Location', category: 'Departure Journey' },
  { value: 'checkedIn', label: 'Checked In (true or false)', category: 'Departure Journey' },
  { value: 'selfAssisted', label: 'Self Assisted', category: 'Departure Journey' },
  { value: 'preBoardDropoffLocation', label: 'Departure Drop off Location', category: 'Departure Journey' },
  { value: 'preBoardTaskNotes', label: 'Departure Notes', category: 'Departure Journey' },
  { value: 'boardingAllocatedTime', label: 'Boarding Allocated Time', category: 'Boarding Journey' },
  { value: 'boardingWaitingTime', label: 'Boarding Waiting Time', category: 'Boarding Journey' },
  { value: 'boardingStartTime', label: 'Boarding Start Time', category: 'Boarding Journey' },
  { value: 'boardingAtLocationTime', label: 'Boarding At Location Time', category: 'Boarding Journey' },
  { value: 'boardingCompleteTime', label: 'Boarding Complete Time', category: 'Boarding Journey' },
  { value: 'boardingDropoffLocation', label: 'Boarding Dropoff Location', category: 'Boarding Journey' },
  { value: 'boardingTaskNotes', label: 'Boarding Task Notes', category: 'Boarding Journey' },
  { value: 'comments', label: 'Task Notes', category: 'Airport Activity' },
  { value: 'notes', label: 'Notes', category: 'Passenger Information' },
  { value: 'lastPosition', label: 'Last Position', category: 'Airport Activity' },


];

//#region async thunks

// Get custom report
export const getCustomReport = createAsyncThunk('timelineReportBuilder/getCustomReport', async (payload, { signal }) => {
  return await CustomReportService.getCustomReportService(payload, signal);
});

// Save custom report
export const saveCustomReport = createAsyncThunk('timelineReportBuilder/saveCustomReport', async (payload) => {
  return await CustomReportService.saveCustomReportService(payload);
});

// get report list
export const getReportList = createAsyncThunk('timelineReportBuilder/getReportList', async (iata) => {
  return await CustomReportService.getReportListService(iata);
});

// delete custom report
export const deleteCustomReport = createAsyncThunk('timelineReportBuilder/deleteCustomReport', async (reportId) => {
  return await CustomReportService.deleteCustomReportService(reportId);
});

//#endregion

//#region initial state
const initialState = {

  reportConfig: null,

  // selected report options
  selectedReport: { label: 'New Report', value: 'New Report' },

  // available columns
  columns: columns,

  // filters
  filters: [],

  // selected columns (array of column values that are enabled)
  selectedColumns: columns.map(col => col.value), // default to all selected

  // date range
  startDate: new Date(),
  endDate: new Date(),

  // filters
  iata: '',
  type: 'all', // 'all', 'inbound', 'outbound'

  // custom report
  customReport: null,
  getCustomReportStatus: 'idle',
  getCustomReportError: null,

  // saved reports list
  reportList: [],
  gettingReportListStatus: 'idle',
  gettingReportListError: null,

  // save custom report
  saveCustomReportStatus: 'idle',
  saveCustomReportError: null,
  savedReport: null,

  // delete custom report
  deleteCustomReportStatus: 'idle',
  deleteCustomReportError: null,

  // report form fields
  reportName: '',
  reportDescription: '',
  reportCategory: { label: 'Select Category', value: '' },

  // advanced settings
  advancedSettings: [],
  preadvisedGrouping: { label: 'type', value: 'Type' },

  // other report builder states can be added here
  // selectedFilters: {},
  // customFields: [],
  // etc.
};
//#endregion

//#region slice
const timelineReportBuilderSlice = createSlice({
  name: 'timelineReportBuilder',
  initialState,
  reducers: {

    setReportConfig: (state, action) => {
      //console.log('setting config ', action.payload)
      state.reportConfig = action.payload;
    },

    setPreadvisedGrouping: (state, action) => {
      state.preadvisedGrouping = action.payload;
    },

    // set selected report
    setSelectedReport: (state, action) => {
      // user report to set state values
      //state.reportConfig = action.payload?.;
      // dropdown object
      state.selectedReport = action.payload?.selectedReport;

      // check if new report
      if (action.payload?.selectedReport?.value === 'New Report') {
        // reset to initial state for new report
        state.reportName = '';
        state.reportDescription = '';
        state.reportCategory = { label: 'Select Category', value: '' };
        state.selectedColumns = columns.map(col => col.value); // all columns
        state.filters = {
          assistance: {},
          agent: {},
          preAdvised: {}
        };
        state.startDate = new Date();
        state.endDate = new Date();
        state.iata = '';
        state.type = 'all';
        state.customReport = null;
        state.getCustomReportStatus = 'idle';
        state.getCustomReportError = null;
        return;
      }
      else {

        // set state from selected report details
        // console.log('setting state from selected report', action.payload.iata)

        // meta
        state.reportName = action.payload?.name || '';
        state.reportDescription = action.payload?.description || '';
        state.reportCategory = action.payload?.category ? { label: action.payload.category, value: action.payload.category } : { label: 'Select Category', value: '' };

        // config
        state.selectedColumns = action.payload?.config?.fields

        // build filters from config
        state.filters = { ...action.payload?.config?.readableFilters };

        // set iata
        state.iata = { label: action?.payload?.iata, value: action?.payload?.iata } || { label: 'SNN', value: 'SNN' };

        // date range
        state.startDate = action.payload?.action?.startDate ? new Date(action.payload.startDate) : new Date();
        state.endDate = action.payload?.action?.endDate ? new Date(action.payload.endDate) : new Date();

      }
    },

    setFilters: (state, action) => {
      state.filters = action.payload;
    },

    // clear all filters
    clearFilters: (state) => {
      state.filters = {
        assistance: { label: 'All', value: 'all' },
        agent: { label: 'All', value: 'all' },
        preAdvised: { label: 'All', value: 'all' }
      };
    },

    // set selected columns
    setSelectedColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },

    // toggle individual column
    toggleColumn: (state, action) => {
      const columnValue = action.payload;
      const index = state.selectedColumns.indexOf(columnValue);
      if (index > -1) {
        state.selectedColumns.splice(index, 1);
      } else {
        state.selectedColumns.push(columnValue);
      }
    },

    // set date range
    setDateRange: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },

    // set IATA
    setIata: (state, action) => {
      state.iata = action.payload;
    },

    // set type
    setType: (state, action) => {
      state.type = action.payload;
    },

    // manually set custom report 
    setCustomReport: (state, action) => {
      state.customReport = action.payload;
    },

    // reset custom report
    resetCustomReport: (state) => {
      state.customReport = null;
      state.getCustomReportStatus = 'idle';
      state.getCustomReportError = null;
    },

    // reset save custom report
    resetSaveCustomReport: (state) => {
      // clear fields
      state.reportName = '';
      state.reportDescription = '';
      state.reportCategory = { label: 'Select Category', value: '' };

      // clear save states
      //state.savedReport = null;
      state.saveCustomReportStatus = 'idle';
      state.saveCustomReportError = null;
    },

    // set report name
    setReportName: (state, action) => {
      state.reportName = action.payload;
    },

    // set report description
    setReportDescription: (state, action) => {
      state.reportDescription = action.payload;
    },

    // set report category
    setReportCategory: (state, action) => {
      state.reportCategory = action.payload;
    },

    setAdvancedSettings: (state, action) => {
      state.advancedSettings = action.payload;
    },

    // reset all state (preserves saved report list)
    reset: (state) => {
      const preservedReportList = state.reportList;
      const preservedGettingReportListStatus = state.gettingReportListStatus;
      const preservedGettingReportListError = state.gettingReportListError;
      const next = { ...initialState };
      next.reportList = preservedReportList;
      next.gettingReportListStatus = preservedGettingReportListStatus;
      next.gettingReportListError = preservedGettingReportListError;
      return next;
    }
  },
  extraReducers: (builder) => {
    builder
      // custom report
      .addCase(getCustomReport.pending, (state) => {
        //console.log('Redux: getCustomReport.pending');
        state.getCustomReportStatus = 'loading';
        state.getCustomReportError = null;
      })
      .addCase(getCustomReport.fulfilled, (state, action) => {
        //console.log('Redux: getCustomReport.fulfilled', action.payload);
        state.getCustomReportStatus = 'succeeded';
        state.customReport = action.payload;
        state.getCustomReportError = null;
      })
      .addCase(getCustomReport.rejected, (state, action) => {
        //console.log('Redux: getCustomReport.rejected', action.error);
        state.getCustomReportStatus = 'failed';
        state.getCustomReportError = action.error.message;

        // clear cache
        state.customReport = null;
      })
      // save custom report
      .addCase(saveCustomReport.pending, (state) => {
        //console.log('Redux: saveCustomReport.pending');
        state.saveCustomReportStatus = 'loading';
        state.saveCustomReportError = null;
      })
      .addCase(saveCustomReport.fulfilled, (state, action) => {
        state.saveCustomReportStatus = 'succeeded';
        state.savedReport = action.payload;
        state.saveCustomReportError = null;

        // console.log('saved report', action.payload)

        // append saved report to report list
        if (state.reportList && state.reportList.data) {
          // change id to _id to match backend response
          action.payload.data._id = action.payload.data.id;
          delete action.payload.data.id;
          state.reportList.data.push(action.payload.data);
        } else {
          // change id to _id to match backend response
          action.payload.data._id = action.payload.data.id;
          delete action.payload.data.id;
          state.reportList = { data: [action.payload.data] };
        }
      })
      .addCase(saveCustomReport.rejected, (state, action) => {
        //console.log('Redux: saveCustomReport.rejected', action.error);
        state.saveCustomReportStatus = 'failed';
        state.saveCustomReportError = action.error.message;

        // clear cache
        state.savedReport = null;
      })
      // get report list
      .addCase(getReportList.pending, (state) => {
        //console.log('Redux: getReportList.pending');
        state.gettingReportListStatus = 'loading';
        state.gettingReportListError = null;
      })
      .addCase(getReportList.fulfilled, (state, action) => {
        //console.log('Redux: getReportList.fulfilled', action.payload);
        state.gettingReportListStatus = 'succeeded';
        state.reportList = action.payload;
        state.gettingReportListError = null;
      })
      .addCase(getReportList.rejected, (state, action) => {
        //console.log('Redux: getReportList.rejected', action.error);
        state.gettingReportListStatus = 'failed';
        state.gettingReportListError = action.error.message;
        state.reportList = [];
      })
      // delete custom report
      .addCase(deleteCustomReport.pending, (state) => {
        state.deleteCustomReportStatus = 'loading';
        state.deleteCustomReportError = null;
      })
      .addCase(deleteCustomReport.fulfilled, (state, action) => {
        state.deleteCustomReportStatus = 'succeeded';
        state.deleteCustomReportError = null;
        // Remove deleted report from report list
        const reportId = action.meta?.arg;
        if (state.reportList?.data && reportId) {
          state.reportList.data = state.reportList.data.filter((r) => r?._id !== reportId);
        }
        // If deleted report was selected, reset to New Report
        if (state.selectedReport?.value === reportId) {
          state.selectedReport = { label: 'New Report', value: 'New Report' };
          state.customReport = null;
        }
      })
      .addCase(deleteCustomReport.rejected, (state, action) => {
        state.deleteCustomReportStatus = 'failed';
        state.deleteCustomReportError = action.error.message;
      });
  }
});
//#endregion

//#region selectors

// advanced settings
export const selectAdvancedSettings = (state) => state.timelineReportBuilder.advancedSettings;
export const selectPreadvisedGrouping = (state) => state.timelineReportBuilder.preadvisedGrouping;

//#region assistance breakdowns
export const selectAssistanceBreakdown = (state) => {
  // check if breakdown in report response is null or undefined
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.breakdowns && state.timelineReportBuilder.customReport.breakdowns['assistance-breakdown']) {
    return state.timelineReportBuilder.customReport.totalBreakdowns['assistance-breakdown'];
  }
  return [];
}

export const selectAssistanceBreakdownColumns = (state) => {
  // check if breakdown in report response is null or undefined
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.breakdowns && state.timelineReportBuilder.customReport.breakdowns['assistance-breakdown']) {
    let list = ['Type', ...PRMCodes]
    return list;
  }
  return [];
}

export const selectAssistanceBreakdownData = (state) => {
  if (
    state.timelineReportBuilder.customReport &&
    state.timelineReportBuilder.customReport.totalBreakdowns &&
    state.timelineReportBuilder.customReport.totalBreakdowns['assistance-breakdown']
  ) {
    let dataList = [];
    let breakdown = state.timelineReportBuilder.customReport.totalBreakdowns['assistance-breakdown'];

    // helper to format each row
    const buildRow = (label, data) => {
      return [
        label,
        ...PRMCodes.map((code) => {
          let match = data.find(item => item?.assistanceCode === code);
          return match
            ? `${match.passengerCount}${match.percentageOfTotalPassengers ? ` (${match.percentageOfTotalPassengers})` : ''}`
            : 0;
        })
      ];
    };

    dataList.push(buildRow('Inbound', breakdown.inbound || []));
    dataList.push(buildRow('Outbound', breakdown.outbound || []));
    dataList.push(buildRow('Total', breakdown.total || []));

    //console.log('DATA list', dataList);
    return dataList;
  }

  return [];
};
//#endregion

//#region preadvised breakdowns
export const selectPreadvisedBreakdown = (state) => {
  // check if breakdown in report response is null or undefined
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.breakdowns && state.timelineReportBuilder.customReport.breakdowns['preadvised-breakdown']) {
    return state.timelineReportBuilder.customReport.totalBreakdowns['preadvised-breakdown'];
  }
  return [];
}

let preadvisedColumns = ['Type', 'Preadvised Count', 'Non Preadvised Count', 'Total Passengers', 'Preadvised %', 'Non Preadvised &'];

export const selectPreadvisedBreakdownColumns = (state) => {
  // check if breakdown in report response is null or undefined
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.breakdowns && state.timelineReportBuilder.customReport.breakdowns['preadvised-breakdown']) {
    return preadvisedColumns;
  }
  return [];
}

export const selectPreadvisedBreakdownData = (state) => {
  // check if breakdown in report response is null or undefined
  if (
    state.timelineReportBuilder.customReport &&
    state.timelineReportBuilder.customReport.totalBreakdowns &&
    state.timelineReportBuilder.customReport.totalBreakdowns['preadvised-breakdown']
  ) {
    let dataList = [];
    let breakdown = state.timelineReportBuilder.customReport.totalBreakdowns['preadvised-breakdown'];

    // helper to format each row
    const buildRow = (label, data) => {
      let preadvisedCount = data.preAdvisedCount || 0;
      let nonPreadvisedCount = data.nonPreadvisedCount || 0;
      let totalPassengers = data.totalCount || 0;
      let preadvisedPercentage = data.preAdvisedPercentage ? `${data.preAdvisedPercentage.toFixed(2)}%` : '0%';
      let nonPreadvisedPercentage = data.nonPreadvisedPercentage ? `${data.nonPreadvisedPercentage.toFixed(2)}%` : '0%';

      return [
        label,
        preadvisedCount,
        nonPreadvisedCount,
        totalPassengers,
        preadvisedPercentage,
        nonPreadvisedPercentage
      ];
    };

    dataList.push(buildRow('Inbound', breakdown.inbound || {}));
    dataList.push(buildRow('Outbound', breakdown.outbound || {}));
    dataList.push(buildRow('Total', breakdown.total || {}));

    return dataList;
  }
  return [];
}
//#endregion

// report config
export const selectReportConfig = (state) => state.timelineReportBuilder.reportConfig;

// selected report
export const selectSelectedReport = (state) => state.timelineReportBuilder.selectedReport;

// columns - always use source of truth (not persisted) so new columns like noShow appear after deployment
export const selectColumns = () => columns;

// selected columns
export const selectSelectedColumns = (state) => state.timelineReportBuilder.selectedColumns;

// date range
export const selectStartDate = (state) => state.timelineReportBuilder.startDate;
export const selectEndDate = (state) => state.timelineReportBuilder.endDate;

// filters
export const selectIata = (state) => state.timelineReportBuilder.iata;
export const selectType = (state) => state.timelineReportBuilder.type;

// save custom report
export const selectSavedReport = (state) => state.timelineReportBuilder.savedReport;
export const selectSaveCustomReportStatus = (state) => state.timelineReportBuilder.saveCustomReportStatus;
export const selectSaveCustomReportError = (state) => state.timelineReportBuilder.saveCustomReportError;

// delete custom report
export const selectDeleteCustomReportStatus = (state) => state.timelineReportBuilder.deleteCustomReportStatus;
export const selectDeleteCustomReportError = (state) => state.timelineReportBuilder.deleteCustomReportError;

// get custom report list
export const selectReportList = (state) => state.timelineReportBuilder.reportList;
export const selectGettingReportListStatus = (state) => state.timelineReportBuilder.gettingReportListStatus;
export const selectGettingReportListError = (state) => state.timelineReportBuilder.gettingReportListError;
export const selectCustomReportsDropdown = (state) => {
  if (state.timelineReportBuilder.reportList?.data && state.timelineReportBuilder?.reportList?.data?.length > 0) {
    // initalize with new report option
    let dropdown = [{ label: 'New Report', value: 'New Report' }];

    dropdown = dropdown.concat(
      // map to dropdown format
      state.timelineReportBuilder.reportList.data.map(report => ({
        label: report.name,
        value: report._id
      }))
    );

    return dropdown;
  }

  // no saved reports, just return new report option
  return [{ label: 'New Report', value: 'New Report' }];

}
export const selectReportListData = (state) => {
  if (state.timelineReportBuilder.reportList && state.timelineReportBuilder.reportList.data) {

    // process each object into a list for the table
    let list = [];

    state.timelineReportBuilder.reportList.data.forEach(report => {

      // console.log('report ', report)

      list.push([
        report?.name,
        report?.description,
        new Date(report?.createdAt).toLocaleDateString(),
        report?.email || 'N/A'
      ])
    });

    return list;
  }
  else {
    return [];
  }
}

// custom report
export const selectCustomReport = (state) => state.timelineReportBuilder.customReport;
export const selectGetCustomReportStatus = (state) => state.timelineReportBuilder.getCustomReportStatus;
export const selectGetCustomReportError = (state) => state.timelineReportBuilder.getCustomReportError;

// data for custom report
export const selectCustomReportColumns = (state) => {
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.columns) {
    // for each data point, 
    return state.timelineReportBuilder.customReport.columns;
  }
  return [];
}

// columns for custom report
export const selectCustomReportData = (state) => {
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.data) {
    return state.timelineReportBuilder.customReport.data;
  }
  else {
    return [];
  }
}

// filters
export const selectFilters = (state) => state.timelineReportBuilder.filters;

// report form fields
export const selectReportName = (state) => state.timelineReportBuilder.reportName;
export const selectReportDescription = (state) => state.timelineReportBuilder.reportDescription;
export const selectReportCategory = (state) => state.timelineReportBuilder.reportCategory;

export const selectReportSummary = (state) => {
  if (state.timelineReportBuilder.customReport && state.timelineReportBuilder.customReport.summary) {
    return state.timelineReportBuilder.customReport.summary;
  }
}

//#endregion

//#region exports
export const {
  setSelectedReport,
  setSelectedColumns,
  toggleColumn,
  setDateRange,
  setIata,
  setType,
  resetCustomReport,
  resetSaveCustomReport,
  reset,
  setFilters,
  clearFilters,
  setReportName,
  setReportDescription,
  setReportCategory,
  setReportConfig,
  setCustomReport,
  setAdvancedSettings,
  setPreadvisedGrouping
} = timelineReportBuilderSlice.actions;

export default timelineReportBuilderSlice.reducer;
//#endregion
